<template>
  <div id="app">
    <el-container>
      <el-header :class="isScroll ? 'scrollHeader' : 'normal'">
        <div class="header-content">
          <div class="logo" @click="toIndex">
            <!--<router-link to="/">-->
              <img src="./assets/img/logo_blue.png" alt v-if="isShow"/>
              <img src="./assets/img/logo_white.png" alt v-else/>
              <!--<span v-if="isShow" style="color: #0086FF;">峰学未来</span>
              <span v-else style="color: #FFFFFF;">峰学未来</span>-->
            <!--</router-link>-->
          </div>
          <el-menu
              :default-active="defaultActive"
              class="el-menu-demo"
              :mode="modeType"
              @select="handleSelect"
              :router="router"
              ref="menu"
          >
            <el-menu-item index="/" :class="isShow ? 'otherClass' : ''">首页</el-menu-item>
            <el-menu-item index="/news" :class="(isShow) ? 'otherClass is-active' : ''" v-if="isDetail">峰学资讯</el-menu-item> <!--is-active-->
            <el-menu-item index="/news" :class="(isShow) ? 'otherClass ' : ''" v-else>峰学资讯</el-menu-item>
            <el-menu-item index="/publicWelfare" :class="isShow ? 'otherClass' : ''">暖峰行动</el-menu-item>
            <el-menu-item index="/download" :class="isShow ? 'otherClass' : ''">下载</el-menu-item>
            <el-menu-item index="/aboutUs" :class="isShow ? 'otherClass' : ''">关于我们</el-menu-item>
          </el-menu>
        </div>

      </el-header>
      <el-main ref="mainRef">
        <router-view />
      </el-main>
      <div class="footer">
        <div class="footer-content">
          <div class="public-content">
            <div class="title">
              <img :src="logoImg"/>
            </div>
            <div class="contact-info">
              <div><img :src="fxwlCode"/><span>峰学未来公众号</span></div>
              <div><img :src="zxfCode"/><span>张雪峰老师公众号</span></div>
              <div><img :src="gaobaoCode"/><span>峰学未来APP合作</span></div>
            </div>
            <!--<img src="./assets/img/ercode.png" alt />-->
          </div>
          <ul class="content-nav">
            <li>
              <p>关于峰学</p>
              <span><router-link to="/">峰学主页</router-link></span>
              <span><router-link to="/news">峰学资讯</router-link></span>
              <span><router-link to="/publicWelfare">暖峰行动</router-link></span>
              <span><router-link to="/aboutUs">关于我们</router-link></span>
            </li>
            <li>
              <p>用户服务</p>
              <span><router-link to="/userAgreement">用户协议</router-link></span>
              <span><router-link to="/policy">隐私政策</router-link></span>
            </li>
          </ul>
        </div>
        <div class="copyright">
          <div class="copy-footer">
            <div class="copy-footer-row">
              <a>Copyright © 2024 苏州峰学蔚来教育科技有限公司版权所有</a>
              <!--<span style="margin-left: 25px;">|</span>
              <span style="margin-left: 10px;"><a href="http://beian.miit.gov.cn" target="_blank" class="recordNum">苏ICP备2022006863号-1</a></span>-->
            </div>
            <div class="copy-footer-row">
              <span><a href="http://beian.miit.gov.cn" target="_blank" class="recordNum">苏ICP备2022006863号-1</a></span>
              <span style="margin-left: 25px;">|</span>
              <img :src="beian" style="margin-left: 25px;"/>
              <span class="beian-content">
                <a href="https://beian.mps.gov.cn/#/query/webSearch?code=32059002004767" target="_blank" class="recordNum" rel='noreferrer' >
                苏公网安备32059002004767
                </a>
              </span>
              <!--<span><a href="http://beian.miit.gov.cn">苏ICP备2022006863号-1</a></span>-->
              <!--<span><a>苏ICP证 苏B2-20220485</a></span>-->
            </div>
          </div>
        </div>
      </div>
      <div style="width: 100%;height: 100%;z-index: 1000;">
        <el-backtop :bottom="60" :right="30">
          <i class="el-icon-upload2"></i>
        </el-backtop>
      </div>
    </el-container>
  </div>
</template>

<script>
import LogoImg from '@/assets/img/logo_white.png';
import fxwlCode from "@/assets/img/fxwlCode.jpg";
import gaobaoCode from "@/assets/img/gaobaoCode.png";
import zxfCode from "@/assets/img/zxfCode.jpg";
import beian from '@/assets/img/beian.png';
export default {
  data() {
    return {
      router: true,
      defaultActive: "/",
      isShow: false,
      mainDivHeight: 0,
      logoImg: LogoImg,
      isScroll:false,
      fxwlCode:fxwlCode,
      gaobaoCode:gaobaoCode,
      zxfCode:zxfCode,
      modeType:'horizontal',
      screenWidth:'',
      isDetail:false,
      beian:beian
    };
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
    /*var _this = this;
    window.onresize = function () {
      // 定义窗口大小变更通知事件
      _this.screenWidth = document.documentElement.clientWidth; //窗口宽度
      _this.handleResize();
    };*/
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  created() {
    if(this.defaultActive === '/' || this.defaultActive === '/news') {
      this.isScroll = false;
    } else {
      this.isScroll = true;
    }
    this.defaultActive = this.$route.path;
  },
  watch:{
    $route() {
      let paths = this.$route.path;
      this.$refs.menu.activeIndex = paths;
      if(paths === "/" || paths === '/download' || paths === '/policy' || paths === '/userAgreement') {
        this.isShow = true;
      } else {
        this.isShow = false;
      }
      if(paths.includes('/newsdetails') || paths.includes('/welfaredetail')) {
        this.isShow = true;
      }
      if(paths.includes('/newsdetails')) {
        this.isDetail = true;
      } else {
        this.isDetail = false;
      }
    },
    /*screenWidth:function (val) {
      window.console.log(val)
      if (val < 1200) {
        this.modeType = 'vertical'
      } else {
        this.modeType = 'horizontal'
      }
    }*/
  },
  methods: {
    handleSelect(key) {
      this.defaultActive = key;
    },
    handleScroll(){
      let scrollTop =  window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop // 获取窗口滚动条高度
      if(scrollTop > 78) {
        this.isScroll = true;
        this.isShow = true;
      } else {
        this.isScroll = false;
        if(this.$route.path === "/" || this.$route.path === '/download' || this.$route.path.includes('/newsdetails') || this.$route.path === '/policy' || this.$route.path === '/userAgreement') {
          this.isShow = true;
        } else {
          this.isShow = false;
        }

      }
    },
    toIndex(){
      this.$router.push('/')
    },
    handleResize(){
      var deviceWidth = document.documentElement.offsetWidth;
      const rootValue = deviceWidth / 1920 * 10; // Change this calculation as needed
      window.console.log(rootValue);
      // Update the HTML font size
      document.documentElement.style.fontSize = `${rootValue}px`;
    },
    setDynamicStyle(){
      if(this.isDetail) {
        this.dynamicStyle = { fontFamily: 'SourceHanSansCNBold',fontWeight:'bold' };
      } else {
        this.dynamicStyle = {};
      }
    }
  }
};
</script>

<style lang="scss">
* {
  padding: 0;
  margin: 0;
}
html,
body {
  height: 100%;
  position: relative;
  scroll-behavior: smooth;
}

@font-face {
  font-family: 'numberFamily';
  src: url('https://oss.kaoyanvip.cn/attach/file1706509867414.ttf');
}
@font-face {
  font-family: 'SourceHanSansCN';
  src: url('https://oss.kaoyanvip.cn/attach/file1706510115645.otf');
}
@font-face {
  font-family: 'SourceHanSansCNBold';
  src: url('https://oss.kaoyanvip.cn/attach/file1706509868791.otf');
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  width: 100%;
  /*min-width: 1200px;*/
  overflow: auto;
}

.el-backtop{
  z-index: 10000;
  width: 48px !important;
  height: 48px !important;
  box-shadow: 0 5px 10px 0 rgba(0,0,0,.1) !important;
  .el-icon-upload2{
    font-weight: bold;
    color: #0A0D0F;
  }
}
.el-backtop:hover{
  background-color: #ffffff !important;
}
.el-image-viewer__canvas{
  width: 60% !important;
  margin: 40px auto;
}
.el-image-viewer__img{
  border-radius: 16px;
  max-height: 90% !important;
  max-width: 70% !important;
 /* height: 83%;*/
}
.el-image-viewer__next{
  background-image: url('~@/assets/img/right-normal.png');
  background-size: cover;
}
.el-image-viewer__next:hover{
  background-image: url('~@/assets/img/right-hover-small.png');
  background-size: cover;
}
.el-image-viewer__prev:hover{
  background-image: url('~@/assets/img/left-hover-small.png');
  background-size: cover;
}
.el-image-viewer__prev{
  background-image: url('~@/assets/img/left-normal.png');
  background-size: cover;
}

.el-header {
  justify-content: space-between;
  align-content: center;
  width: 100%;
  position: fixed;
  height: 78px !important;
  margin: 0 auto;
  z-index: 100000;
  padding: 0 0 !important;

  .el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 200px;
    min-height: 400px;
  }

  .header-content{
    display: flex;
    justify-content: space-between;
    align-content: center;
    width: 100%;
    max-width: 1200px;
    min-width: 748px;
    margin: 0 auto;
    /*position: fixed;*/
    /*left: 50%;
    transform: translate(-50%, 0);*/
  }
  .logo {
    width: 150px;
    padding: 25px;
    display: flex;
    line-height: 60px;
    padding-left: 0;
    cursor: pointer;
    img {
      width: 139px;
      height: 26px;
      /*margin-top: 4px;*/
    }
    span{
      font-size: 20px;
      font-family: 'SourceHanSansCNBold Microsoft YaHei' !important;
      font-weight: 400;
      color: #0086FF;
      line-height: 30px;
      margin-left: 10px;
    }
    .scrollType{
      color: #0086FF;
    }
  }
  .el-menu{
    background-color: transparent;
    border-bottom: none !important;
    .el-menu-item{
      padding: 0 0 0 60px;
      height: 78px;
      line-height: 78px;
      font-size: 18px;
      color: #FFFFFF;
      font-family: 'SourceHanSansCN Microsoft YaHei' !important;
      border-bottom: none !important;
    }
    .otherClass{
      height: 78px;
      line-height: 78px;
      font-size: 18px;
      color: #0A0D0F !important;
      font-family: 'SourceHanSansCN Microsoft YaHei' !important;
    }
  }
  .el-menu--horizontal>.el-menu-item.is-active{
    border-bottom: none !important;
    font-weight: bold;
    color: #FFFFFF;
    font-family: 'SourceHanSansCNBold Microsoft YaHei' !important;
  }
  .el-menu--horizontal>.el-menu-item:not(.is-disabled):focus, .el-menu--horizontal>.el-menu-item:not(.is-disabled):hover, .el-menu--horizontal>.el-submenu .el-submenu__title:hover {
    background-color: transparent !important;
    color: #FFFFFF !important;
    font-weight: bold;
    font-family: 'SourceHanSansCNBold Microsoft YaHei' !important;
  }
  .el-menu--horizontal>.el-menu-item:hover{
    background-color: transparent !important;
    color: #FFFFFF !important;
    font-weight: bold;
    font-family: 'SourceHanSansCNBold Microsoft YaHei' !important;
  }
  .el-menu--horizontal>.otherClass.is-active{
    border-bottom: none !important;
    font-weight: bold;
    color: #0A0D0F;
    font-family: 'SourceHanSansCNBold Microsoft YaHei' !important;
  }
  .el-menu--horizontal>.otherClass:not(.is-disabled):focus, .el-menu--horizontal>.otherClass:not(.is-disabled):hover, .el-menu--horizontal>.el-submenu .el-submenu__title:hover {
    background-color: transparent !important;
    color: #0A0D0F !important;
    font-weight: bold;
    font-family: 'SourceHanSansCNBold Microsoft YaHei' !important;
  }
  .el-menu--horizontal>.otherClass:hover{
    background-color: transparent !important;
    color: #0A0D0F !important;
    font-weight: bold;
    font-family: 'SourceHanSansCNBold Microsoft YaHei' !important;
  }
}
.scrollHeader{
  background: rgba(255,255,255,0.9);
  box-shadow: 0 0 50px rgba(0,0,0,.05);
  backdrop-filter: blur(30px);
  transition: .2s ease;
  transition-property: top,transform;
  .el-menu{
    background-color: transparent;
    border-bottom: none !important;
    .el-menu-item{
      height: 78px;
      line-height: 78px;
      font-size: 18px;
      color: #434649;
      font-family: 'SourceHanSansCN Microsoft YaHei';
    }
  }
  .el-menu--horizontal>.el-menu-item.is-active{
    border-bottom: none !important;
    font-weight: bold;
    color: #FFFFFF;
    font-family: 'SourceHanSansCNBold Microsoft YaHei' !important;
  }
  .el-menu--horizontal>.el-menu-item:hover{
    background-color: transparent !important;
    color: #FFFFFF !important;
  }
  .el-menu--horizontal>.otherClass.is-active{
    border-bottom: none !important;
    font-weight: bold;
    color: #0A0D0F;
    font-family: 'SourceHanSansCNBold Microsoft YaHei' !important;
  }
  .el-menu--horizontal>.otherClass:hover{
    background-color: transparent !important;
    color: #0A0D0F !important;
  }
}
.el-main {
  padding: 0 !important;
  height: auto;
  /*position: absolute;
  top: 0;
  z-index: 100;*/
}

.footer {
  width: 100%;
  height: 500px;
  overflow: hidden;
  background: #23262C;
  z-index: 1000;
  .footer-content {
    width: 1200px;
    margin: 0 auto;
    padding-top: 80px;
    overflow: hidden;
    display: flex;
    justify-content: space-between;
    .public-content{
      width: 40%;
      float: left;
      /*text-align: center;*/
      .title{
        display: flex;
        justify-content: flex-start;
        img{
          width: 139px;
          height: 26px;
        }
        span{
          font-size: 16px;
          font-family: 'SourceHanSansCNBold Microsoft YaHei' !important;
          font-weight: bold;
          color: rgba(255,255,255,0.8);
          line-height: 30px;
          margin-left: 10px;
        }
      }
      .contact-info{
        /*width: 120px;*/
        margin-top: 50px;
        display: flex;
        justify-content: space-between;
        div{
          width: 130px;
          text-align: center;
          img{
            width: 120px;
            border-radius: 4px;
          }
          span{
            display: inline-block;
            font-size: 16px;
            font-family: 'SourceHanSansCN Microsoft YaHei';
            font-weight: 400;
            color: rgba(255,255,255,0.6);
            line-height: 21px;
            margin-top: 12px;
          }
        }
      }
    }
    .content-nav {
      display: flex;
      justify-content: space-between;
      float: left;
      /*margin-left: 25%;*/
      width: 55%;
      li {
        display: flex;
        flex-direction: column;
        padding: 0 20px;
        //justify-content: center;
        align-items: flex-start;
        /*margin-right: 10%;*/
        cursor: pointer;
        margin-left: 215px;
        p {
          font-size: 18px;
          font-family: 'SourceHanSansCNBold Microsoft YaHei' !important;
          font-weight: bold;
          color: rgba(255,255,255,0.8);
          line-height: 24px;
          /*padding: 5px 0;*/
          padding-bottom: 50px;
        }
        span {
          font-size: 16px;
          font-family: 'SourceHanSansCN Microsoft YaHei';
          font-weight: 400;
          color: rgba(255,255,255,0.6);
          line-height: 21px;
          padding-bottom: 30px;
          a{
            text-decoration: none;
            color: rgba(255,255,255,0.6);
          }
          a:active{
            font-weight: bold;
            font-family: 'SourceHanSansCNBold Microsoft YaHei' !important;
            color: rgba(255,255,255,0.8);
          }
          a:hover{
            color: rgba(255,255,255,1);
          }
        }
      }
    }
  }
  .copyright {
    width: 1200px;
    height: 30px;
    background: #23262C;
    margin: 0 auto;
    margin-top: 20px;
    text-align: center;
    border-top: 1px solid rgba(255,255,255,0.1);
    padding: 30px 0;
    .copy-footer{
      box-sizing: border-box;
      .copy-footer-row{
        display: flex;
        justify-content: center;
        height: 30px;
        line-height: 30px;
        text-align: justify;
        align-items: center;
        a{
          font-size: 14px;
          font-family: ' Microsoft YaHei Microsoft YaHei';
          font-weight: 400;
          color: rgba(255,255,255,0.3);
          line-height: 21px;
          text-decoration: none;
        }
        span{
          font-size: 14px;
          font-family: 'SourceHanSansCN Microsoft YaHei';
          font-weight: 400;
          color: rgba(255,255,255,0.3);
          line-height: 21px;
          a{
            padding: 0 8px;
          }
        }
        .recordNum:hover{
          color: #0086FF;
        }
        img{
          width: 30px;
        }
        /*.beian-content{
          display: flex;
          justify-content: center;
          height: 30px;
          line-height: 30px;
          img{

          }
        }*/
      }
    }
  }

  ::v-deep .el-backtop{
    z-index: 10000;
    width: 48px;
    height: 48px;
    box-shadow: 0 5px 10px 0 rgba(0,0,0,.1);
    .el-icon-upload2{
      font-weight: bold;
      color: #0A0D0F;
    }
  }
  ::v-deep .el-backtop:hover{
    background-color: #ffffff;
  }
}
</style>
